module.exports = __webpack_public_path__ + "img/02.009401ce.png";